import { ReportsProvider, ReportsService } from "@sportal/api/reports";
import { HttpService } from "@sportal/api";

export const makeReportsService = (
  http: HttpService,
  baseUrl: string
): ReportsService => new ReportsService(new ReportsProvider(http, baseUrl));
